// @ts-check

import { buildCsv } from './csv';
import { cleanMeasurements, MEASUREMENT_FIELDS, validateMeasurements } from './customerMeasurements';

/** First problem with a lead capture, or null when it is ready to submit. */
export function validateLeadForm(form) {
  if (!form.name.trim()) return "Enter the person's name";
  if (form.phone.replace(/\D/g, '').length < 7) return 'Enter a phone number (at least 7 digits)';
  if (!form.phoneCountry) return "Choose the phone number's country";
  const problem = validateMeasurements(form.measurements);
  if (problem) return problem;
  return null;
}

const clean = (value) => {
  const text = (value ?? '').trim();
  return text === '' ? null : text;
};

/** Body for POST /api/admin/walk-in-leads. */
export function buildLeadPayload(form, salesEventId) {
  return {
    sales_event_id: salesEventId,
    name: form.name.trim(),
    phone: form.phone.trim(),
    phone_country: form.phoneCountry,
    style: clean(form.style),
    size_tried: clean(form.sizeTried),
    notes: clean(form.notes),
    measurements: cleanMeasurements(form.measurements),
    fit_notes: clean(form.fitNotes),
    preferred_product_id: form.preferredProductId || null,
  };
}

/**
 * CSV for follow-up outside the app - built client-side from already-authenticated data (the
 * `list` endpoint's response), since a plain `<a href>` download can't carry the auth header the
 * admin API requires.
 * @param {Array<{name: string, phone: string, style?: string | null, size_tried?: string | null, notes?: string | null, measurements?: Record<string, number> | null, fit_notes?: string | null}>} leads
 */
export function buildLeadsCsv(leads) {
  /** @type {Array<Array<string | number | null | undefined>>} */
  const rows = [
    ['Name', 'Phone', 'Style', 'Size', ...MEASUREMENT_FIELDS.map((f) => f.label), 'Fit note', 'Notes'],
  ];
  for (const lead of leads) {
    rows.push([
      lead.name,
      lead.phone,
      lead.style || '',
      lead.size_tried || '',
      ...MEASUREMENT_FIELDS.map((f) => lead.measurements?.[f.key] ?? ''),
      lead.fit_notes || '',
      lead.notes || '',
    ]);
  }
  return buildCsv(rows);
}
